const items = [
  "Tráfego Pago",
  "Design",
  "Web Performance",
  "IA & Automações",
  "Apps Nativos & PWA",
  "Growth Marketing",
];

const Track = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex w-max shrink-0 items-center">
    {items.map((item, i) => (
      <span key={item} className="flex items-center">
        <span
          className={`px-8 font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl ${
            i % 2 === 0 ? "text-paper" : "text-stroke-neon"
          }`}
        >
          {item}
        </span>
        <span className="h-2.5 w-2.5 rotate-45 bg-brand-neon shadow-[0_0_18px_rgba(168,85,247,0.9)]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section className="relative border-y border-paper/5 bg-surface/40 py-8 sm:py-10">
    <div className="flex w-max animate-marquee">
      <Track />
      <Track hidden />
    </div>
  </section>
);

export default Marquee;
